import { type ComponentPropsWithoutRef, createContext, useContext, useRef } from "react";

import { Button } from "@virtual-brain-lib/frontend-design-system/ui";
import { copyHtmlToClipboard } from "@virtual-brain-lib/frontend-utils";

const NestedTableContext = createContext(false);

export default function MarkdownTable({
	children,
	...props
}: Readonly<ComponentPropsWithoutRef<"table">>) {
	const tableRef = useRef<HTMLTableElement>(null);
	const isNested = useContext(NestedTableContext);

	function handleCopyTable() {
		if (tableRef.current) {
			const html = tableRef.current.outerHTML;

			copyHtmlToClipboard(html, "table", "Table copied to clipboard");
		}
	}

	return (
		<NestedTableContext.Provider value>
			<div className="group relative w-fit max-w-full">
				{!isNested && (
					<Button
						size="sm"
						variant="outlineWhite"
						leftIcon="copy"
						className="pointer-events-none absolute top-5 right-1 z-10 opacity-0 transition-opacity group-hover:pointer-events-auto group-hover:opacity-100"
						tooltip={{ children: "Copy table to clipboard" }}
						onClick={handleCopyTable}
					/>
				)}
				<div className="overflow-x-auto">
					<table ref={tableRef} {...props}>
						{children}
					</table>
				</div>
			</div>
		</NestedTableContext.Provider>
	);
}
